export default __webpack_public_path__ + "static/media/bg.78cee6bb.jpg";